import { render, staticRenderFns } from "./ProvidersListLabel.vue?vue&type=template&id=0174b05a&"
import script from "./ProvidersListLabel.vue?vue&type=script&lang=js&"
export * from "./ProvidersListLabel.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersListLabel.vue?vue&type=style&index=0&id=0174b05a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports